(function () {
    'use strict';

    angular
        .module('app.test')
        .constant('testResolver', {
            data: getData
        });

    function getData() {
        return [];
    }
})();